import { styled, Fab as FabMui } from '@mui/material';

interface Kind {
  basic: string;
  positive: string;
  negative: string;
  active: string;
  'no-active': string;
  dark: string;
}

export type KindKeys = keyof Kind;

const getButtonStyles = (theme: any, kind: KindKeys) => {
  const { button } = theme.status;

  const base = {
    borderRadius: 17,
    color: '#ffffff',
  };

  switch (kind) {
    case 'positive':
      return {
        ...base,
        backgroundColor: button.positive.default,
        '&:hover': { backgroundColor: button.positive.hover },
        '&:active': { backgroundColor: button.positive.active },
        '&:disabled': { backgroundColor: button.positive.disabled },
        '&:pressed': { backgroundColor: button.positive.pressed },
      };
    case 'negative':
      return {
        ...base,
        backgroundColor: button.negative.default,
        '&:hover': { backgroundColor: button.negative.hover },
        '&:active': { backgroundColor: button.negative.active },
        '&:disabled': { backgroundColor: button.negative.disabled },
        '&:pressed': { backgroundColor: button.negative.pressed },
      };
    case 'active':
      return {
        ...base,
        backgroundColor: button.active.default,
        boxShadow: 'none',
        '&:hover': { backgroundColor: button.active.hover },
        '&:active': { backgroundColor: button.active.active },
        '&:disabled': { backgroundColor: button.active.disabled },
        '&:pressed': { backgroundColor: button.active.pressed },
      };
    case 'no-active':
      return {
        ...base,
        backgroundColor: button.active['no-active'],
        boxShadow: 'none',
        '&:hover': { backgroundColor: button.active['no-active'] },
        '&:active': { backgroundColor: button.active['no-active'] },
        '&:disabled': { backgroundColor: button.active['no-active'] },
        '&:pressed': { backgroundColor: button.active['no-active'] },
      };
    case 'dark':
      return {
        ...base,
        backgroundColor: button.dark.default,
        boxShadow: 'none',
        '&:hover': { backgroundColor: button.dark.hover },
        '&:active': { backgroundColor: button.dark.active },
        '&:disabled': { backgroundColor: button.dark.disabled },
        '&:pressed': { backgroundColor: button.dark.pressed },
      };
    case 'basic':
    default:
      return {
        ...base,
        backgroundColor: button.basic.default,
        color: '#ffffff !important',
        '&:hover': { backgroundColor: button.basic.hover },
        '&:active': { backgroundColor: button.basic.active },
        '&:disabled': { backgroundColor: button.basic.disabled },
        '&:pressed': { backgroundColor: button.basic.pressed },
      };
  }
};

export const Fab = styled(FabMui)<{
  iconSize: number | string;
  kind: KindKeys;
  active: boolean;
  withMargin: boolean;
}>(({ theme, iconSize, kind, withMargin }) => ({
  zIndex: 'auto',
  width: iconSize,
  height: iconSize,
  minHeight: iconSize,
  minWidth: iconSize,
  marginRight: withMargin ? '10px' : undefined,
  ...getButtonStyles(theme, kind),
}));
